export default __webpack_public_path__ + "images/a9480cb2f17ac808a207089d7f40d9f5.png";